module.exports = __webpack_public_path__ + "static/media/senti_dots.3fecb15e.svg";